import { getConfigTenant, isCorpTenant } from "./getTenant";

export const getPortalName = () => {
  const isCorporate = isCorpTenant(getConfigTenant());
  return isCorporate ? "Capital One Business Travel" : "Capital One Travel";
};
